import React, { useContext } from "react";
import PropTypes from "prop-types";
import { LocalesContext } from "../contexts/LocalesContext";
import {
  getOptionsTranslation,
  presetSensibilitaGraficoOptions,
  presetGraficoDiDefaultOptions,
} from "../utils/miplus";
import { convertValue, getUnit } from "../utils/unitsConverter";

export default function ConfResumeComponent(props) {
  const { t } = useContext(LocalesContext);
  const isImperial = props.unitsSystem === 'imperial';

  return (
    <div>
      {/* File Management Section */}
      <table className="c-table" style={{ marginBottom: '30px' }}>
        <thead>
            <tr>
                <th>{t("GestioneFile")}</th>
                <th></th>
            </tr>    
        </thead>
        <tbody>
          <tr>
            <th>{t("NumeroFile")}</th>
            <td>
              {props.configuration.setupFile && (
                <>{props.configuration.setupFile.length || props.numeroFile}</>
              )}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Configuration Section */}
      <table className="c-table">
        <thead>
            <tr>
                <th>{t("Configurazione")}</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
          <tr>
            <th>{t("Interfila")}</th>
            <td>
              {convertValue(props.configuration.interfila, 'length', isImperial)} {getUnit('length', isImperial)}
            </td>
          </tr>
          <tr>
            <th>{t("DistanzaSemina")}</th>
            <td>
              {convertValue(props.configuration.distanzaSemina, 'length', isImperial)} {getUnit('length', isImperial)}
            </td>
          </tr>
          <tr>
            <th>{t("Investimento")}</th>
            <td>
              {convertValue(props.configuration.investimento, 'investment', isImperial)} {getUnit('investment', isImperial)}
            </td>
          </tr>
          <tr>
            <th>{t("NumeroForiDisco")}</th>
            <td>{props.configuration.numeroForiDisco} n°</td>
          </tr>
          <tr>
            <th>{t("DiametroForiDisco")}</th>
            <td>
              {convertValue(props.configuration.diametroForiDisco / 10, 'height', isImperial)} {getUnit('height', isImperial)}
            </td>
          </tr>
          <tr>
            <th>{t("GraficoDiDefault")}</th>
            <td>
              {getOptionsTranslation(
                presetGraficoDiDefaultOptions(t),
                props.configuration.graficoDefault
              )}
            </td>
          </tr>
          <tr>
            <th>{t("SensibilitaGrafico")}</th>
            <td>
              {getOptionsTranslation(
                presetSensibilitaGraficoOptions(t),
                props.configuration.sensibilitaGrafico
              )}
            </td>
          </tr>
          <tr>
            <th>{t("SogliaAllarmeQualita")}</th>
            <td>{props.configuration.sogliaAllarmeQualita}%</td>
          </tr>
          <tr>
            <th>{t("SogliaAllarmePopolazione")}</th>
            <td>{props.configuration.sogliaAllarmePopolazione}%</td>
          </tr>
          <tr>
            <th>{t("LivelloAllarmeGrafico")}</th>
            <td>{props.configuration.livelloAllarmeGrafico}%</td>
          </tr>
          <tr>
            <th>{t("LivelloDepressioneMin")}</th>
            <td>
              {convertValue(props.configuration.livelloDepressioneMin, 'pressure', isImperial)} {getUnit('pressure', isImperial)}
            </td>
          </tr>
          <tr>
            <th>{t("LivelloDepressioneMax")}</th>
            <td>
              {convertValue(props.configuration.livelloDepressioneMax, 'pressure', isImperial)} {getUnit('pressure', isImperial)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

ConfResumeComponent.propTypes = {
  configuration: PropTypes.object.isRequired,
  numeroFile: PropTypes.number,
  unitsSystem: PropTypes.string,
};

ConfResumeComponent.defaultProps = {
  configuration: {},
  numeroFile: 24,
  unitsSystem: 'metric'
};